export default {"src":"/_next/static/media/combo_chart.06bd2097.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};